import $axios from "../http/accessor";
import { profile } from "../endpoints/profile.endpoints";

const ProfileService = {
  getProfile: () => $axios.get(profile.me),
  updateProfile: (formData: FormData) =>
    $axios.put(profile.me, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

export default ProfileService;
